import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import type { Component } from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import {
  BackOfficeHostingPlatforms,
  ComponentType,
} from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { getExtensionPath } from '@wix/cli-astro-definitions';

// NOTE: path is relative to the build folder
const DASHBOARD_PAGE_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/dashboard-page'
);

export async function generateDashboardPage(
  projectFolder: string,
  route: string,
  title: string
) {
  const component: Component = {
    compId: randomUUID(),
    compType: ComponentType.BACK_OFFICE_PAGE,
    compName: title,
    compData: {
      backOfficePage: {
        hostingPlatform: BackOfficeHostingPlatforms.BUSINESS_MANAGER,
        routePath: route,
        title,
      },
    },
  };

  const cwd = getExtensionPath(projectFolder, route);

  const pageConfigJSON = toJsonString(component, { spaces: 2 });
  const relativeRoutePath = path.join(cwd, 'page.tsx');

  return await componentGenerator({
    template: DASHBOARD_PAGE_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      route,
      title,
      relativeRoutePath,
      pageConfigJSON,
    },
  });
}
